export const GET_TEZOS_NODE = 'GET_TEZOS_NODE';
export const GET_PROTOCOL_ADDRESSES = 'GET_PROTOCOL_ADDRESSES';
export const GET_COMPTROLLER = 'GET_COMPTROLLER';
